<ng-container *ngIf="isMobileMode && !(isMobileSigning$ | async); else desktopMode">
  <bom-mobile-page></bom-mobile-page>
</ng-container>

<ng-template #desktopMode>
  <bom-layout-page [isMobileSigning$]="isMobileSigning$"></bom-layout-page>
  <link rel="stylesheet" [href]="themeCss" />
</ng-template>
